import { useLanguage } from '@/lib/i18n';
import { usePageMeta, seoData } from '@/lib/seo';
import ContactForm from '@/components/ContactForm';

export default function ContactPage() {
  const { t, lang } = useLanguage();
  const seo = seoData[lang].contact;
  usePageMeta({ title: seo.title, description: seo.description, path: '/contact', lang });

  return (
    <main className="pt-28 pb-20" data-testid="contact-page">
      <div className="max-w-2xl mx-auto px-6 lg:px-8">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white text-center mb-12">{t.contact.h2}</h1>
        <ContactForm />
      </div>
    </main>
  );
}
